<template>
    <focus-lock>
        <div
            role="dialog"
            aria-modal="true"
            :aria-label="$t('COSPLAY_PACK')"
            :class="[
                `cz2__sb-attach-pack-modal--sb-type-${sbType}`,
                { 'is-kiosk': isKiosk },
            ]"
            class="cz2__attach-pack-modal cz2__sb-attach-pack-modal"
        >
            <div class="cz2__attach-pack-modal-content">
                <div class="cz2__sb-attach-pack-modal-background" />

                <div
                    class="cz2__sb-attach-pack-modal-logo-m"
                />

                <div
                    class="cz2__sb-attach-pack-modal-logo-d"
                />

                <div
                    class="cz2__sb-attach-pack-modal-logo-k"
                />

                <div class="cz2__attach-pack-modal-pics">
                    <div
                        :aria-label="$t('YOUR_CUSTOM_POP')"
                        :style="{
                            'background-image': `url('${popSnapshot}')`,
                        }"
                        class="cz2__attach-pack-modal-snapshot cz2__full-height"
                    />

                    <p
                        :aria-label="$t('PLUS')"
                        class="plus"
                    >
                        &plus;
                    </p>

                    <div
                        :aria-label="customAttributes['fun-style-clean']"
                        class="cz2__attach-pack-modal-pack-wrapper cz2__full-height"
                    >
                        <div
                            :style="{
                                'background-image': `url('${previewImage}')`,
                            }"
                            class="cz2__attach-pack-modal-pack cz2__full-width cz2__full-height"
                        />
                    </div>
                </div>

                <div
                    :style="{
                        color: customAttributes['fun-modal-copy-font-color'],
                    }"
                >
                    <h1 class="cz2__attach-pack-modal-heading cz2__font-sb">
                        {{ customAttributes['fun-modal-heading'] }}
                    </h1>

                    <p class="cz2__attach-pack-modal-copy cz2__font-sb">
                        {{ customAttributes['fun-modal-copy'] }}
                    </p>

                    <p class="cz2__attach-pack-modal-price"
                    >
                        <span>—</span>
                        {{ priceFormatted }} {{ $t('EACH') }}
                        <span>—</span>
                    </p>
                </div>

                <div class="cz2__attach-pack-modal-buttons">
                    <sb-button
                        variant="tertiary"
                        heightVariant="medium"
                        @click="closeModal"
                    >
                        {{ $t('NO_THANKS') }}
                    </sb-button>

                    <sb-button
                        :disabled="!attachPackModalComponent.canAdd"
                        @click="addPack"
                        variant="primary"
                        heightVariant="medium"
                    >
                        {{ $t('ADD_ATTACH_PACK') }}
                    </sb-button>
                </div>
            </div>
        </div>
    </focus-lock>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__sb-attach-pack-modal {
            padding: 50px 0px 40px;

            @include respond-above(lg) {
                padding: 50px 0 50px;
            }

            background-size: 50%;
            background-position: center;
            background-repeat: repeat;

            &.cz2__sb-attach-pack-modal--sb-type-none {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(lg) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__sb-attach-pack-modal--sb-type-G {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(lg) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__sb-attach-pack-modal--sb-type-H {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                @include respond-above(lg) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                }
            }

            &.cz2__sb-attach-pack-modal--sb-type-S {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                @include respond-above(lg) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                }
            }

            &.cz2__sb-attach-pack-modal--sb-type-R {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                @include respond-above(lg) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                }
            }

            background-size: cover;

            background-image: none;
            background-color: transparent;

            position: absolute;
            border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_M@2x.webp');

            border-width: 40px;
            border-image-width: 40px;
            border-image-slice: 80 fill;
            border-image-repeat: stretch;

            height: 100%;
            width: 100%;

            @include respond-above(lg) {
                border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_D@2x.webp');
                height: 100%;
                width: 100%;
                border-width: 70px;
                border-image-width: 70px;
                border-image-slice: 140 fill;
                border-image-repeat: stretch;
            }

            .cz2__attach-pack-modal-buttons {
                width: 800px;
                max-width: calc(100vw - 100px);
            }

            .cz2__sb-attach-pack-modal-background {
                background-image: url("../assets/images/branded/sb-final/SB-Background_pattern_3_M@2x.jpg");

                background-repeat: repeat;
                background-size: 100%;
                background-position: center;
                background-origin: border-box;
                background-color: #fff;

                position: absolute;

                left: 35px;
                top: 35px;

                height: calc(100% - 70px);
                width: calc(100% - 70px);

                z-index: -1;

                @include respond-above(lg) {
                    left: 70px;
                    top: 70px;

                    height: calc(100% - 140px);
                    width: calc(100% - 140px);

                    background-image: url("../assets/images/branded/sb-final/SB-Background_pattern_4_D@2x.jpg");
                }
            }

            .plus {
                width: 20px;
                text-align: center;

                @include respond-above(lg) {
                    width: 60px;
                }
            }

            .cz2__attach-pack-modal-snapshot {
                width: calc(50% - 10px) !important;
                background-position: right center !important;

                transform: scale(1.1);

                @include respond-above(sm) {
                    transform: scale(1.0);
                }

                @include respond-above(md) {
                    transform: scale(1.1);
                }

                @include respond-above(lg) {
                    width: calc(50% - 30px) !important;
                }
            }

            .cz2__attach-pack-modal-pack-wrapper {
                padding: 0 !important;
                padding-left: 0px !important;

                width: calc(50% - 10px) !important;

                .cz2__attach-pack-modal-pack {
                    transform: scale(1.1) translate(0, -3%);
                }

                @include respond-above(sm) {
                    .cz2__attach-pack-modal-pack {
                        transform: scale(1.0) translate(0, -3%);
                    }
                }

                @include respond-above-height(md, short) {
                    padding-left: 0px !important;
                    padding-top: 0px !important;
                    padding-bottom: 0px !important;

                    width: calc(50% - 30px) !important;

                    .cz2__attach-pack-modal-pack {
                        transform: scale(1) translate(0, -4.7%);
                    }
                }

                @include respond-above-height(md, medium) {
                    padding-left: 0px !important;
                    padding-top: 0px !important;
                    padding-bottom: 0px !important;

                    width: calc(50% - 30px) !important;

                    .cz2__attach-pack-modal-pack {
                        transform: scale(1.1) translate(0, -4.7%);
                    }
                }

                @include respond-above-height(lg, short) {
                    padding-left: 0px !important;
                    padding-top: 0px !important;
                    padding-bottom: 0px !important;

                    width: calc(50% - 30px) !important;

                    .cz2__attach-pack-modal-pack {
                        transform: scale(1) translate(0, -4.7%);
                    }
                }

                @include respond-above-height(lg, medium) {
                    padding-left: 0px !important;
                    padding-top: 0px !important;
                    padding-bottom: 0px !important;

                    width: calc(50% - 30px) !important;

                    .cz2__attach-pack-modal-pack {
                        transform: scale(1.1) translate(0, -4.7%);
                    }
                }
            }

            .cz2__attach-pack-modal-pack {
                background-position: left center !important;
            }

            .cz2__sb-attach-pack-modal-logo-m, .cz2__sb-attach-pack-modal-logo-d, .cz2__sb-attach-pack-modal-logo-k {
                display: none;

                width: 100%;
                min-height: 60px;

                margin: auto;
            }

            .cz2__sb-attach-pack-modal-logo-m {
                display: block;

                width: 262px;
                top: 50px;

                @include respond-above-height(lg, short) {
                    display: none;
                }
            }

            .cz2__sb-attach-pack-modal-logo-d {
                @include respond-above-height(lg, short) {
                    display: block;
                    background-image: url("../assets/images/branded/sb-final/SB-Logo_1_D@2x.webp");
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: top;
                    height: 100%;
                    max-height: 160px;
                }
            }

            .cz2__sb-attach-pack-modal-logo-m {
                top: 7%;
                display: block;
                background-image: url("../assets/images/branded/sb-final/SB-Logo_1_M@2x.webp");
                background-size: contain;
                background-repeat: no-repeat;
                background-position: top;
                height: 100%;
                width: 100%;
                max-height: 15%;
                max-width: 60%;

                @include respond-above-height(lg, short) {
                    display: none;
                }
            }

            .cz2__attach-pack-modal-heading {
                font-size: 24px;

                @include respond-above-height(lg, short) {
                    font-size: 38px;
                }

                @include respond-above-height(xl, medium) {
                    font-size: 55px;
                }
            }

            .cz2__attach-pack-modal-copy {
                margin-top: 8px;
                margin-bottom: 8px;

                width: 1050px;
                max-width: calc(100vw - 80px);

                font-size: 16px;
                font-family: "Proxima Nova", sans-serif !important;
                text-align: center;
                font-weight: 500;

                @include respond-above-height(lg, short) {
                    font-size: 24px;
                }

                @include respond-above-height(xl, medium) {
                    margin-top: 36px;
                    margin-bottom: 24px;

                    font-size: 38px;
                }
            }

            .cz2__attach-pack-modal-price {
                color: #112344;

                font-style: normal !important;
                font-size: 16px;
                margin-left: 0 !important;
                font-family: "Proxima Nova", sans-serif !important;
                text-align: center;
                font-weight: 600;

                @include respond-above-height(lg, short) {
                    font-size: 24px;
                }

                @include respond-above-height(xl, medium) {
                    font-size: 40px;
                }
            }

            &.is-kiosk {
                .cz2__attach-pack-modal-content {
                    padding-top: 80px;
                }

                .cz2__sb-attach-pack-modal-background {
                    background-size: 210%;
                    background-position: 0 0;
                }

                .cz2__attach-pack-modal-pics {
                    width: 90%;
                }

                .cz2__attach-pack-modal-heading {
                    font-size: 75px;
                }

                .cz2__attach-pack-modal-copy {
                    margin-top: 24px;

                    font-size: 38px;
                }

                .cz2__attach-pack-modal-price {
                    margin-top: 56px;

                    font-size: 40px;
                }

                .cz2__attach-pack-modal-buttons {
                    padding-top: 85px;
                    padding-bottom: 160px;

                    flex-direction: column-reverse;
                    align-items: center;
                }

                .cz2__attach-pack-modal-pack {
                    transform: scale(1.0) translate(0, -4.7%);
                }
            }
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    import SbButton from './SbButton.vue';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            FocusLock,
            SbButton,
        },

        data() {
            return {
                currency: 'USD',
            };
        },

        computed: {
            attachPackModalComponent() {
                return this.$store.state.attachPackModalComponent;
            },

            customAttributes() {
                return this.attachPackModalComponent.component.custom;
            },

            sbType() {
                return this.customAttributes['fun-sb-type'] ?? 'none';
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },

            modalBgImage() {
                let bgImage = this.customAttributes['fun-modal-bg-d-image'];

                if (this.isMobile) {
                    bgImage = this.customAttributes['fun-modal-bg-m-image'];
                } else if (this.isKiosk) {
                    bgImage = this.customAttributes['fun-modal-bg-k-image'];
                }

                return bgImage;
            },

            previewImage() {
                if (this.customAttributes['fun-modal-costume-image']) {
                    return this.customAttributes['fun-modal-costume-image'];
                }

                const sku = this.customAttributes['fun-sku'];

                return `//api.images.drivecommerce.com/api/v1/image/funko/CZ-Icon-v2-${sku}`;
            },

            popSnapshot() {
                return this.$store.state.customizer.attachPacksPreviewImage;
            },

            priceFormatted() {
                return this.formatPrice(this.attachPackModalComponent.price);
            },
        },

        mounted() {
            if (this.customAttributes['fun-modal-font']) {
                this.addFont(this.customAttributes['fun-modal-font']);
            }

            if (this.customAttributes['fun-modal-cta-font']) {
                this.addFont(this.customAttributes['fun-modal-cta-font']);
            }

            if (this.customAttributes['fun-modal-price-font']) {
                this.addFont(this.customAttributes['fun-modal-price-font']);
            }
        },

        methods: {
            closeModal() {
                this.$store.dispatch('setAttachPackModalComponent', null);
                this.$store.dispatch('showAttachPackModal', false);
            },

            addPack() {
                this.$store.dispatch('setAttachPackAddComponent', this.attachPackModalComponent);

                this.closeModal();
            },

            formatPrice(price) {
                const v = this.priceValue(price);

                if (v == null || v === 0) {
                    return this.$t('ITEM_FREE');
                }

                return formatPrice(this.$store.state, v.value, 'standard');
            },

            priceValue(price) {
                if (price == null) {
                    return 0;
                }

                if (typeof price === 'number') {
                    return { value: price };
                }

                return price.find((p) => p.currencyCode === this.currency);
            },

            addFont(url) {
                const link = document.createElement('link');

                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = url;

                document.getElementsByTagName('HEAD')[0].appendChild(link);
            },
        },
    };
</script>
